// extracted by mini-css-extract-plugin
module.exports = {"gameInfo":"gameInfo_gameInfo__5RmGF","upsetAlert":"gameInfo_upsetAlert__00luC","infoLeft":"gameInfo_infoLeft__mCCjp","infoRight":"gameInfo_infoRight__ocFaz"};